<template>
  <v-card>
    <v-btn @click="$emit('close')" absolute right class="mt-3" icon>
      <v-icon>fas fa-times</v-icon>
    </v-btn>
    <v-btn class="mr-12 mt-3" style="min-width: auto" absolute right color="primary" small @click="print">
      <v-icon>fas fa-print</v-icon>
    </v-btn>
    <v-card-text id="infoTaxSalaryWrap">
      <v-card-title><h4 style="word-break: normal; padding-right: 65px">Сведение о заработной плате</h4></v-card-title>
      <column-table style="margin-bottom: 15px;" v-if="userData" :data="userData.user" :rows="userInfoTableHeaders"/>
      <v-data-table
        v-if="userData"
        hide-default-footer
        disable-pagination
        :headers="userIncomeTableHeaders"
        :items="userData.months"
      >
        <template #item.salary="{item: {salary}}"><span class="text-no-wrap">{{salary|money}}</span></template>
        <template #item.salary_tax_sum="{item: {salary_tax_sum}}"><span class="text-no-wrap">{{salary_tax_sum|money}}</span></template>
        <template #item.inps_sum="{item: {inps_sum}}"><span class="text-no-wrap">{{inps_sum|money}}</span></template>
        <template #item.prop_income="{item: {prop_income}}"><span class="text-no-wrap">{{prop_income|money}}</span></template>
        <template #item.other_income="{item: {other_income}}"><span class="text-no-wrap">{{other_income|money}}</span></template>
      </v-data-table>
    </v-card-text>
  </v-card>
</template>

<script>
import ColumnTable from "@/components/ui/table/ColumnTable";
import printTaxInfoMixin from "@/components/calculation/calculator-tax/printTaxInfoMixin";

export default {
  name: 'InfoTaxSalary',
  props: {
    userData: {
      type: Object
    }
  },
  data() {
    return {
      userInfoTableHeaders: [
        {
          text: 'ИНН физического лица',
          value: 'tin'
        },
        {
          text: 'Ф.И.О',
          value: 'name'
        },
        {
          text: 'ПИНФЛ физического лица',
          value: 'pinfl'
        },
        {
          text: 'Серия паспорта',
          value: 'series_passport'
        },
        {
          text: 'Номер паспорта',
          value: 'number_passport'
        }
      ],
      userIncomeTableHeaders: [
        {
          text: 'Наименование работодателя',
          value: 'company_name'
        },
        {
          text: 'ИНН работодателя',
          value: 'company_tin'
        },
        {
          text: 'Дата',
          value: 'date'
        },
        {
          text: 'Зарплата',
          value: 'salary'
        },
        {
          text: 'Уплаченный налог на доходы',
          value: 'salary_tax_sum'
        },
        {
          text: 'Уплаченная сумма на пенсионный фонд',
          value: 'inps_sum'
        },
        {
          text: 'Начисленный имущественный доход',
          value: 'prop_income'
        },
        {
          text: 'Прочие доходы',
          value: 'other_income'
        }
      ],
    }
  },
  mixins: [printTaxInfoMixin('infoTaxSalaryWrap')],
  components: {ColumnTable}
}
</script>